"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const button_1 = __importDefault(require("../../material-button/button"));
require("../../../styles/components/modal/confirmation-modal.less");
const ConfirmationModal = ({ isOpen, title, showHeaderCloseButton, className, closeModal, isLoading, confirmationMessage, disableBackdropClick, disableEscapeKeyDown, cancelText, onCancel, submitText, onSubmit, submitButtonDisabled, showCancel, showSubmit, submitTooltip }) => {
    const closeButton = showHeaderCloseButton ? react_1.default.createElement("span", { className: "material-icons close", onClick: closeModal }, "close") : '';
    return (react_1.default.createElement(Dialog_1.default, { open: isOpen, classes: { root: `confirmation-dialog confirmation-modal ${className}`, paper: 'confirmation-dialog-paper' }, onClose: closeModal, disableEscapeKeyDown: disableEscapeKeyDown, disableBackdropClick: disableBackdropClick },
        title ? (react_1.default.createElement(DialogTitle_1.default, { className: "dialog-title" }, title)) : '',
        closeButton,
        react_1.default.createElement(DialogContent_1.default, { className: "dialog-content" },
            react_1.default.createElement("div", { className: "confirmation-msg" }, confirmationMessage)),
        react_1.default.createElement(DialogActions_1.default, { className: "dialog-actions" },
            showCancel && react_1.default.createElement(button_1.default, { className: "confirmation-dialog-button cancel", onClick: onCancel }, cancelText),
            showSubmit && react_1.default.createElement(button_1.default, { className: "confirmation-dialog-button submit", variant: "contained", color: "primary", isLoading: isLoading, onClick: onSubmit, disabled: submitButtonDisabled, title: submitTooltip }, submitText))));
};
ConfirmationModal.defaultProps = {
    isOpen: false,
    closeModal: noop_1.default,
    className: '',
    submitButtonDisabled: false,
    isLoading: false,
    showCancel: true,
    cancelText: '',
    onCancel: noop_1.default,
    showSubmit: true,
    submitText: '',
    onSubmit: noop_1.default,
    showHeaderCloseButton: false,
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    submitTooltip: '',
};
ConfirmationModal.propTypes = {
    isOpen: prop_types_1.default.bool,
    isLoading: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    closeModal: prop_types_1.default.func,
    confirmationMessage: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]).isRequired,
    cancelText: prop_types_1.default.string,
    onCancel: prop_types_1.default.func,
    submitText: prop_types_1.default.string,
    onSubmit: prop_types_1.default.func,
    submitButtonDisabled: prop_types_1.default.bool,
    showCancel: prop_types_1.default.bool,
    showSubmit: prop_types_1.default.bool,
    showHeaderCloseButton: prop_types_1.default.bool,
    disableEscapeKeyDown: prop_types_1.default.bool,
    disableBackdropClick: prop_types_1.default.bool,
    submitTooltip: prop_types_1.default.string,
};
exports.default = ConfirmationModal;
//# sourceMappingURL=confirmation-modal.js.map